import { useContext } from "react";
import "./sidebar.styles.scss";
import { Options, SideBarContext } from "../../context/sidebar.context";
import { Link } from "react-router-dom";

const SideBar = ({ isFormOpen }) => {
    const { selectedOption, setSelectedOption } = useContext(SideBarContext)
    return (
      <>
        <div className="sidebar">
          <div className="header__secondary sidebar__header">
            <h3>Admin Panel</h3>
          </div>
          <div className="sidebar__links">
            <ul className={isFormOpen && "u-disabled"}>
              {/* <li>Dashboard</li> */}
              <li
                className={
                  selectedOption === Options.Destinations &&
                  "sidebar__links--selected"
                }
                // onClick={() => setSelectedOption(Options.Destinations)}
              >
                <Link
                  to={"/admin"}
                  onClick={() => setSelectedOption(Options.Destinations)}
                  className="sidebar__links"
                >
                  Destinations
                </Link>
              </li>
              <li
                className={
                  selectedOption === Options.Adventures &&
                  "sidebar__links--selected"
                }
              >
                <Link
                  to={"/admin/adventure"}
                  onClick={() => setSelectedOption(Options.Adventures)}
                  className="sidebar__links"
                >
                  Adventures
                </Link>
              </li>
              <li
                className={
                  selectedOption === Options.Programmes &&
                  "sidebar__links--selected"
                }
              >
                <Link
                  to={"/admin/programme"}
                  onClick={() => setSelectedOption(Options.Programmes)}
                  className="sidebar__links"
                >
                  Programmes
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </>
    );
}

export default SideBar;